/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Billing_CycleInputs */

const en_admin_resource_form_billing_cycle = /** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing Cycle`)
};

const de_admin_resource_form_billing_cycle = /** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrechnungszyklus`)
};

const es_admin_resource_form_billing_cycle = /** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciclo de facturación`)
};

const fr_admin_resource_form_billing_cycle = /** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cycle de facturation`)
};

const nl_admin_resource_form_billing_cycle = /** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factureringsperiode`)
};

/** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */
const it_admin_resource_form_billing_cycle = en_admin_resource_form_billing_cycle;

/** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */
const pt_br2_admin_resource_form_billing_cycle = en_admin_resource_form_billing_cycle;

/** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */
const pl_admin_resource_form_billing_cycle = en_admin_resource_form_billing_cycle;

/** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */
const hu_admin_resource_form_billing_cycle = en_admin_resource_form_billing_cycle;

/** @type {(inputs: Admin_Resource_Form_Billing_CycleInputs) => LocalizedString} */
const ro_admin_resource_form_billing_cycle = en_admin_resource_form_billing_cycle;

/**
* | output |
* | --- |
* | "Billing Cycle" |
*
* @param {Admin_Resource_Form_Billing_CycleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_billing_cycle = /** @type {((inputs?: Admin_Resource_Form_Billing_CycleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Billing_CycleInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_billing_cycle(inputs)
	if (locale === "de") return de_admin_resource_form_billing_cycle(inputs)
	if (locale === "es") return es_admin_resource_form_billing_cycle(inputs)
	if (locale === "fr") return fr_admin_resource_form_billing_cycle(inputs)
	if (locale === "nl") return nl_admin_resource_form_billing_cycle(inputs)
	if (locale === "it") return it_admin_resource_form_billing_cycle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_billing_cycle(inputs)
	if (locale === "pl") return pl_admin_resource_form_billing_cycle(inputs)
	if (locale === "hu") return hu_admin_resource_form_billing_cycle(inputs)
	return ro_admin_resource_form_billing_cycle(inputs)
});
export { admin_resource_form_billing_cycle as "admin.resource_form.billing_cycle" }